// extracted by css-extract-rspack-plugin
export default {"modal":"Modal_modal__JttUg","fullscreen":"Modal_fullscreen__Ws-7U"};